import { useEffect } from 'react';

import { createTranslatedText, useFormController, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { AudioInputDevice, getDefaultAudioInputDevice } from '../../audio/audioInputDevices';
import { useAudioInputDevices } from '../../audio/useAudioInputDevices';
import { useAiAssistantMicrophoneGlobalState } from '../../shared/useAiAssistantMicrophoneGlobalState';
import { translationKeys } from '../../translations';

import { AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelectFormBean } from './AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelect.types';

const t = translationKeys.mainMenuTileItem.soundSource;

export const AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelect = (): JSX.Element => {
   const translate = useTranslate();
   const devices = useAudioInputDevices();
   const { device, setDevice } = useAiAssistantMicrophoneGlobalState();

   const { register, setValue } = useFormController<AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelectFormBean>(
      {
         microphone: device,
      }
   );

   useEffect(() => {
      const selectedDeviceAvailable = devices.some((item) => item.id === device?.id);
      if (selectedDeviceAvailable) {
         return;
      }

      const defaultDevice = getDefaultAudioInputDevice(devices);
      if (defaultDevice) {
         setDevice(defaultDevice);
         setValue('microphone', defaultDevice);
      }
   }, [devices, device, setDevice, setValue]);

   const triggerLabelExtractor = (item: AudioInputDevice): string =>
      translate(createTranslatedText(item.label) ?? t.unnamedMicrophone);

   return (
      <Select<AudioInputDevice>
         testId={'microphone'}
         placeholder={t.microphonePlaceholder}
         controller={register('microphone')}
         triggerLabelExtractor={triggerLabelExtractor}
         onSelect={setDevice}
         compact
         width={'376px'}
      >
         <Select.List<AudioInputDevice> items={devices} keyExtractor={'id'}>
            {(item) => <Select.Item item={item} testId={item.id} label={createTranslatedText(item.label)} />}
         </Select.List>
      </Select>
   );
};
